export default {"src":"/_next/static/media/alchemy-logo.d5ba41e0.svg","height":28,"width":131,"blurWidth":0,"blurHeight":0};